<template>
    <div class="pt-16">
        <div class="relative">
            <div class="lg:absolute lg:top-0 lg:right-0 lg:h-full lg:w-[calc(50%+4.5rem)] xl:w-[calc(50%+5rem)] z-1">
                <div class="relative w-full h-[calc(35vw+6.5rem)] lg:h-full overflow-hidden">
                    <object
                        tabindex="-1"
                        class="absolute -bottom-1 left-0 sm:hidden"
                        type="image/svg+xml"
                        style="filter: none"
                        aria-hidden="true"
                        :data="require('assets/images/shapes/waves/article-hero-wave_sm.svg')"
                    ></object>
                    <object
                        tabindex="-1"
                        class="absolute -bottom-1 left-0 hidden sm:block lg:hidden"
                        type="image/svg+xml"
                        style="filter: none"
                        aria-hidden="true"
                        :data="require('assets/images/shapes/waves/article-hero-wave_md.svg')"
                    ></object>
                    <object
                        tabindex="-1"
                        class="absolute bottom-0 -left-1 hidden lg:block"
                        type="image/svg+xml"
                        style="filter: none"
                        aria-hidden="true"
                        :data="require('assets/images/shapes/waves/article-hero-wave_lg.svg')"
                    ></object>
                    <picture>
                        <source media="(min-width:992px)" :srcset="$getMediaImage(model.media, 'hero', 'lg')" />
                        <source media="(min-width:480px)" :srcset="$getMediaImage(model.media, 'hero', 'md')" />
                        <img
                            :src="$getMediaImage(model.media, 'hero', 'sm')"
                            :alt="model.title"
                            class="w-full h-full object-cover"
                        />
                    </picture>
                </div>
            </div>
            <div class="container relative py-4 lg:py-12 lg:min-h-[600px] z-2">
                <div class="grid grid-cols-12 base-responsive-gap">
                    <div class="col-span-12 lg:col-span-5 order-2 lg:order-1 relative">
                        <h1 class="header-2 mb-4 lg:mb-8">{{ model.title }}</h1>
                        <div class="auxiliary-text font-bold uppercase text-sm mb-4 lg:mb-8">
                            <span>
                                {{ $dayjs(model.published_at).format('YYYY/MM/DD') }}
                            </span>
                            <span v-if="model.category_id" class="inline">
                                <span class="separator-bullet"></span>
                                <T t="news.archive.title" />
                            </span>
                        </div>
                        <div class="lead" v-html="model.lead_text"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="relative">
            <a id="main-content" class="absolute -top-32" tabindex="-1"></a>
            <div class="container mt-6 hidden lg:block reoative">
                <Breadcrumb :items="breadcrumbItems" />
            </div>
        </div>

        <EditableContentComponentGroup
            :components="model.components"
            compact
            class="mt-8 lg:mt-20 bg-theme-dark--swiper"
        />
    </div>
</template>

<script>
import Breadcrumb from '@/components/Generic/Breadcrumb.vue';
import EditableContentComponentGroup from '@/components/Generic/EditableContentComponentGroup.vue';

export default {
    name: 'Article',
    components: {
        EditableContentComponentGroup,
        Breadcrumb,
    },
    layout: 'theme-dark',
    async asyncData({ $axios, params, redirect, localePath, i18n }) {
        let model = null;

        await $axios
            .$get(`/news/by-slug/${params.article}`)
            .then((res) => {
                model = res;
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('archive'));
        }

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'article');

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('news.archive.title'), 'archive']);
        breadcrumbItems.push([model.title, 'article']);

        return {
            model,
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>

<style scoped></style>
